<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>{{ title }}</h1>

  <div class="create-fax-rule-modal">
    <div class="create-fax-rule-modal__row">
      <span class="create-fax-rule-modal__label">On</span>

      <app-select
        [items]="triggerTypes"
        [activeItem]="triggerType"
        [customClass]="['select_m']"
        (selectChange)="onTriggerTypeSelect($event)"
      ></app-select>
    </div>

    <h2 class="create-fax-rule-modal__title">When I get Fax with all of the selected conditions</h2>

    <label class="create-fax-rule-modal__condition">
      <input
        type="radio"
        name="direction"
        class="create-fax-rule-modal__radio"
        [checked]="direction === FaxRuleDirection.From"
        (change)="direction = FaxRuleDirection.From"
      />
      <span class="create-fax-rule-modal__condition-label">From:</span>
      <input
        type="text"
        class="form-input_md create-fax-rule-modal__condition-input"
        [disabled]="direction !== FaxRuleDirection.From"
        [(ngModel)]="fromNumber"
      />
    </label>

    <label class="create-fax-rule-modal__condition">
      <input
        type="radio"
        name="direction"
        class="create-fax-rule-modal__radio"
        [checked]="direction === FaxRuleDirection.To"
        (change)="direction = FaxRuleDirection.To"
      />
      <span class="create-fax-rule-modal__condition-label">To:</span>
      <input
        type="text"
        class="form-input_md create-fax-rule-modal__condition-input"
        [disabled]="direction !== FaxRuleDirection.To"
        [(ngModel)]="toNumber"
      />
    </label>

    <h2 class="create-fax-rule-modal__title">Do the following</h2>

    <div class="create-fax-rule-modal__row">
      <span class="create-fax-rule-modal__label">Move the item to folder:</span>

      <app-select
        [items]="folderNames"
        [activeItem]="folderName"
        [customClass]="['select_m']"
        placeholder="Select folder"
        [titleMaxLength]="10"
        (selectChange)="onFolderSelect($event)"
      ></app-select>
    </div>

    <button
      type="button"
      class="btn_primary btn_sm create-fax-rule-modal__submit"
      [disabled]="isSubmitDisabled"
      (click)="onSubmit()"
    >
      Save
    </button>
  </div>
</app-base-modal>
